import {
  mapActions
} from 'vuex'
export default {
  methods: {
    ...mapActions([
      'alertToggle',
      'fetchData'
    ]),
    _requestData() {
      //请求开始
      this.loading = true;
      this.loading1 = true;
      this.loading2 = true;
      this.loading3 = true;
      this.loading4 = true;
      this.didInvalidate = false;
    },
    refreshData() {
      this.didInvalidate = true;
    },
    _shouldFetchList() {
      if (!this.loading) {
        return true;
      }
      return this.didInvalidate;
    },
    handleClosePopover(event, index){
      $('body').trigger('click')
    },
    handlePageChange(val, size) {
      this.page = val
      this.pageSize && (this.pageSize = size)
      this._reloadData()
    },
    submitFilter() {
      this.page = 1
      this._reloadData()
    },
    fetchDataIfNeeded(params) {
      if (this._shouldFetchList()) {
        this._fetch(params)
      }
    },
    _receiveData() {
      //请求结束
      this.loading = false;
      this.loading1 = false;
      this.loading2 = false;
      this.loading3 = false;
      this.loading4 = false;
      this.didInvalidate = false;
    },
    // 更新表格行的key
    updateRowKey(row) {
      return row.id + Math.random()
    }
  }
}
